
import React, { FC, useEffect, useState } from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'

import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { PrivateRoutes } from './PrivateRoutes'
import { Logout, AuthPage } from '../modules/auth'

import AuthService from '../modules/auth/redux/AuthService'

const Routes: FC = () => {

  const [isAuthorized, setIsAuthorized] = useState<boolean>(false)
  const usr = AuthService.GetCurrentUser();

  useEffect(() => {  
    if(usr && usr.token && usr.userData && usr.userData.sessionGuid ){
      setIsAuthorized(true)
    }
   
  }, [usr])

  return (
    <Switch>
      {!(usr && usr.token && usr.userData && usr.userData.sessionGuid ) ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from='/auth' to='/' />
      )}

      {/* <Route path='/error' component={ErrorsPage} /> */}
      <Route path='/logout' component={Logout} />

      {!(usr && usr.token && usr.userData && usr.userData.sessionGuid ) ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to='/auth/login' />
      ) : (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      )}
    </Switch>
  )
}

export { Routes }
